import React from 'react';
import IconName from "../../svgLogo/SvgLogo";
import SkeletonSingleProduct from "./SkeletonSingleProduct";

const SkeletonPromoProducts = () => {
    return (
        <div className="special-offer-skeleton-wrapper xmt-16">
            <div className="container">
                <div className="timer-wrapper d-flex justify-content-between align-items-center">
                        <div className="wrapper br-5 skeleton-loading position-relative">
                            <div className="child br-5 skeleton-loading position-absolute"></div>
                        </div>
                    <div className="more-button"><IconName name="chevron_left" className="icon"/></div>
                </div>
                <div className="border-slider-status skeleton-loading position-relative xmt-4">
                    <div className="show-slider skeleton-loading position-absolute"></div>
                </div>
                <div className="skeleton-product-wrapper d-flex xmt-6">
                    <SkeletonSingleProduct color="purple"/>
                    <SkeletonSingleProduct color="gray"/>
                    <SkeletonSingleProduct color="purple"/>
                    <SkeletonSingleProduct color="purple"/>
                </div>
            </div>
        </div>
    );
};

export default SkeletonPromoProducts;
